import React, {Component} from 'react';
import styles from './Neighbourhood.scss';
import {connect} from 'react-redux';

import {
	getNeighbourhoods
} from "../../../actions/Map/dataActions";
import {setNeighbourhood} from '../../../actions/Map/navActions';

import NeighbourhoodTemplate from './NeighbourhoodTemplate'

import north from "./Icons/north.png";
import downtown from "./Icons/downtown.png";
import east from "./Icons/east.png";
import west from "./Icons/west.png";

class Neighbourhood extends Component {

 constructor(props) {
   super(props);
   this.state = {
     neighbourhood: undefined,
     recommended_neighbourhoods: undefined,
     selectedTag: "Downtown / Inner Suburb"
   }
 }

 componentDidUpdate(prevProps, prevState){
   if (prevProps.neighbourhoods !== this.props.neighbourhoods){
     this.getDataFromURL();
   }
   if (prevProps.location.search !== this.props.location.search){
     this.getDataFromURL();
   }
   if (prevProps.location.search !== this.props.location.search
    && this.props.location.search === ""){
     this.setState({
       neighbourhood: undefined,
       recommended_neighbourhoods: undefined
     })
   }
 }

 componentDidMount() {
   this.getDataFromURL();
   this.props.getNeighbourhoods();

 }

 getDataFromURL = () => {
   // Get id from query string if possible
   var queryString = this.props.location.search
   if (queryString !== undefined){
     // Get results of survey
     queryString = queryString.replace("?", "");
     const queryArray = queryString.split("&");
     for (var i=0; i < queryArray.length; i++){
       let pair = queryArray[i].split("=")
       // If there is one neighbourhood to display
       if (pair[0] === "id") {
         for (var j=0; j < this.props.neighbourhoods.length; j++){
           if (this.props.neighbourhoods[j].fields.neighbourhood_id === pair[1]){
             let hood = this.props.neighbourhoods[j]
             var name = hood.fields.name;
             var url = hood.fields.realtor_url;
             var desc = hood.fields.desc;
           }
         }
         this.setState({ neighbourhood: {
           "id": pair[1],
           "name": name,
           "url": url,
           "desc": desc
         }})
       }
       // If it is the results of the survey page
       else if (pair[0] === "results"){
         const recommended = pair[1].split(","); //.map(Number);
         this.setState({ recommended_neighbourhoods: recommended })
       }
     }
   }
   else {
     this.props.setNeighbourhood(undefined)
   }
 }

 componentWillUnmount(){
   this.setState({
     neighbourhood: undefined,
     recommended_neighbourhoods: undefined
   });
 }
	// Filter neighbourhoods based on the selected tag
  handleTagSelect = (e) => {
		let img = e;
		let p = img + "p";
		let previousTag = this.state.selectedTag;
		let previousTagp = previousTag + "p";

		// check if the tag selected is not the same as the previous tag
		if (e !== this.state.selectedTag) {
			// Make current selected tag opacity 1
			document.getElementById(img).style.opacity="1";
			document.getElementById(p).style.opacity="1";

			// Make the previous selected tag opacity 0.7
			document.getElementById(previousTag).style.opacity="0.7";
			document.getElementById(previousTagp).style.opacity="0.7";

	    this.setState({
	      selectedTag: e
	    });
		}
  }

 render() {
     return (
       <div className={styles.Neighbourhoods}>
			 <div style={{textAlign: 'center'}}>
				{!!(!this.state.recommended_neighbourhoods) && (
				<div>
				{!(!this.props.neighbourhoods.length) &&
				 <div className="row col-8 mx-auto">
					 <div className="col-sm-3"><a className={styles.buttonImage} onClick={() => this.handleTagSelect("Downtown / Inner Suburb")}><img  id="Downtown / Inner Suburb" style={{marginBottom: 6.5, opacity: 1}} src={downtown} alt="Downtown"/><p id="Downtown / Inner Suburbp"  style={{opacity: 1}} >Downtown</p></a></div>
					 <div className="col-sm-3"><a className={styles.buttonImage} onClick={() => this.handleTagSelect("Kingston - North")}><img id="Kingston - North" src={north} alt="North"/><p id="Kingston - Northp">North</p></a></div>
					 <div className="col-sm-3"><a className={styles.buttonImage} onClick={() => this.handleTagSelect("Kingston - East")}><img id="Kingston - East" src={east} alt="East"/><p id="Kingston - Eastp">East</p></a></div>
					 <div className="col-sm-3"><a className={styles.buttonImage} onClick={() => this.handleTagSelect("Kingston - West")}><img id="Kingston - West" src={west} alt="West"/><p id="Kingston - Westp">West</p></a></div>
				 </div>}
				</div>
				)}
				</div>
         {/* Display Recommened Neighbourhood From Survey Results */}
         {!(!this.state.recommended_neighbourhoods) && (

          this.state.recommended_neighbourhoods.map((id) => {
             for (var i=0; i< this.props.neighbourhoods.length; i++){
               if (this.props.neighbourhoods[i].fields.neighbourhood_id === id){
                 let hood = this.props.neighbourhoods[i]
                 var name = hood.fields.name
                 var url =  hood.fields.realtor_url
                 var desc = hood.fields.desc
               }
             }
             return (
             <NeighbourhoodTemplate
                key={id}
                id={id}
                name={name}
                url={url}
                desc={desc}
								identify={"first function"}
              />
             )
           })
         )
       }

       {/* Display Neighbourhood From URL */}
       {this.state.neighbourhood &&
       !this.state.recommended_neighbourhoods &&
       this.props.neighbourhoods && (
          <NeighbourhoodTemplate
            selectedTag={this.state.selectedTag}
            key={this.state.neighbourhood.id}
            id={this.state.neighbourhood.id}
            name={this.state.neighbourhood.name}
            url={this.state.neighbourhood.url}
            desc={this.state.neighbourhood.desc}
						identify={"second function"}
          />
       )}

       {/* Display All Neighbourhoods */}
       {!!(!this.state.neighbourhood) &&
         !!(!this.state.recommended_neighbourhoods) &&
         !(!this.props.neighbourhoods) && (
         this.props.neighbourhoods.map((hood) => {
           return (
           <NeighbourhoodTemplate
             selectedTag={this.state.selectedTag}
              key={hood.recordid}
              id={hood.fields.neighbourhood_id}
              name={hood.fields.name}
              url={hood.fields.realtor_url}
              desc={hood.fields.desc}
							identify={"third function"}
            />
           )

         })
       )
     }

     <div className={styles.disclaimer}>These results and neighbourhood profiles are based on data collected by <a target="_blank" rel="noopener noreferrer" href="https://www.environicsanalytics.com/en-ca/">Environics Analytics</a>.</div>
     </div>
   )}
}

function mapStateToProps(state) {
  return {
    neighbourhoods: state.nav.neighbourhoods,
    // selected_neighbourhood: state.nav.selected_neighbourhood,
    selected_neighbourhood_name: state.nav.selected_neighbourhood_name,
    selected_neighbourhood_desc: state.nav.selected_neighbourhood_desc,
  };
}

const actions = { setNeighbourhood, getNeighbourhoods };

export default connect(mapStateToProps, actions)(Neighbourhood);



// WEBPACK FOOTER //
// ./src/components/pages/Neighbourhood/Neighbourhood.js